import React, { useEffect } from "react";
import { FaUsers, FaStar, FaCheckCircle } from "react-icons/fa";
import styles from "./Mentorships.module.scss";
import PaypalLogo from "../../assets/paypal-logo.png";
import MercadopagoLogo from "../../assets/MP_RGB_HANDSHAKE_pluma_horizontal.svg";

const plans = [
  {
    name: "Plan Observador",
    price: "10 USD",
    priceSuffix: "/mes",
    icon: <FaUsers />,
    text: `Accedé al detrás de escena de un taller real.

Este plan es para quienes quieren aprender viendo cómo se resuelven casos reales, sin participar activamente.

📌 ¿Qué incluye?

🔧 Acceso al grupo de WhatsApp
Vas a ver diagnósticos, fallas reales y cómo se resuelven en el día a día

🧠 Aprendizaje constante
Aprendés simplemente observando casos reales (mucho más que teoría)

⚠️ IMPORTANTE
No incluye consultas privadas
No podés hacer preguntas en el grupo
No incluye envío de manuales

🔥 Ideal si:
Querés aprender sin involucrarte activamente
Estás empezando y querés entender cómo trabajan otros
Buscás una opción más accesible para formarte

💡 Resultado
Vas a empezar a entender cómo se diagnostica una moto de verdad.`,
    checks: [],
    paypalHref:
      "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4UT729245A048073FNHCZPZQ",
    mpHref:
      "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084934d1f1701936d0906240a54",
  },
  {
    name: "Grupo de soporte Motoasesor",
    price: "40 USD",
    priceSuffix: "/mes",
    icon: <FaStar />,
    text: `No es un grupo más.
Es soporte real de taller + cómo mejorar tus diagnósticos y hacer rentable tu trabajo.

👨🏽‍🔧 ¿Para quién es?
Mecánicos que quieren diagnosticar mejor
Personas que quieren resolver sus propias motos
Dueños de talleres que buscan ganar más y ordenarse

📌 ¿Qué incluye?

🔧 Resolución de fallas reales (casos del día a día)
🧠 Explicación técnica clara (sin cambiar piezas “a ciegas”)
🛠 Recomendación de herramientas y uso correcto
📈 Cómo cobrar mejor y hacer rentable tu taller


💬 SOPORTE + COMUNIDAD
Consultas privadas directas conmigo
Grupo de WhatsApp activo (casos reales + aprendizaje constante)
📚 EXTRA

Manuales de taller a pedido

🔥 Resultado
Vas a diagnosticar mejor, evitar errores y dejar de perder plata.`,
    checks: [],
    paypalHref:
      "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-77S34522MS866783FNHLE4MY",
    mpHref:
      "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084915406c2019157a56ed60143",
  },
];

const Mentorships = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.page}>
      <div className="wrapper">
        <h1 className={styles.title}>
          Nuestros <span>Planes</span>
        </h1>
        <p className={styles.subtitle}>
          Elegí el plan que mejor se adapte a tus necesidades y empezá a recibir
          soporte profesional hoy mismo
        </p>

        <div className={styles.cards}>
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={styles.card}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardIcon}>{plan.icon}</div>
                <span className={styles.cardPlanName}>{plan.name}</span>
              </div>
              <div className={styles.cardPrice}>
                {plan.price}
                <span>{plan.priceSuffix}</span>
              </div>
              <p className={styles.cardText}>{plan.text}</p>
              {/*               <div className={styles.checks}>
                {plan.checks.map((check) => (
                  <div key={check} className={styles.check}>
                    <FaCheckCircle />
                    <span>{check}</span>
                  </div>
                ))}
              </div> */}
              <div className={styles.cardActions}>
                <a
                  href={plan.paypalHref}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.btnPaypal}
                >
                  {plan.paypalLabel || "Unirme"}
                  <img src={PaypalLogo} alt="PayPal" />
                </a>
                {plan.mpHref && (
                  <a
                    href={plan.mpHref}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.btnMercadopago}
                  >
                    Unirme
                    <img src={MercadopagoLogo} alt="MercadoPago" />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.whySection}>
          <p className={styles.whyLabel}>¿Por qué elegirnos?</p>
          <p className={styles.whyText}>
            Más de <span>500 motociclistas</span> ya confían en nuestro soporte
            y asesoramiento profesional
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mentorships;
